<template>
  <ul :class="isVerticalStyle ? 'vertical' : 'horizontal'">
    <li v-for="(menu, index) in menus"
      :key="index"
      :class="activeMenu&&activeMenu.label === menu.label ? 'active' : ''"
      @click="clickLevel1(index)">
      {{ menu.label }}
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['isVerticalStyle'],
  computed: {
    ...mapState('menu', ['menus', 'activeMenu']),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const path = this.$route.path;
      const pathArr = path.split('/');
      const subPath = pathArr[2];
      const index = this.menus.findIndex((row) => {
        return row.submenus.map(item => item.subPath).includes(subPath);
      });
      if (~index) {
        this.$store.commit('menu/setMenu', this.menus[index]);
      } else {
        // 没有匹配地址时处理
        this.$store.commit('menu/setMenu', this.menus[0]);
      }
    },
    clickLevel1(index) {
      const oldMenu = this.activeMenu;
      const newMenu = this.menus[index];
      this.$store.commit('menu/setMenu', newMenu);
      // 切换一级功能
      if (oldMenu !== newMenu) {
        this.$store.commit('menu/setSubmenu', null);
        this.$store.commit('menu/setCurrentDevice', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables';
@import '~styles/mixins';

ul {
  padding: 0;
  &.horizontal {
    margin: 5px 0;
    overflow-x: auto;
    white-space: nowrap;
    li {
      @include commonMenuItem;
      @include horizontalMenuItem;
    }
  }
  &.vertical {
    margin: 10px;
    li {
      @include commonMenuItem;
      @include verticalMenuItem;
    }
  }
}
</style>
